import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import ColumnBox from "components/ColumnBox";
import { apiHelper, baseUrl } from "helpers/util";

// Dynamic import for QRCode to handle compatibility issues
let QRCode = null;
try {
  QRCode = require("react-qr-code").default;
} catch (error) {
  console.warn("QRCode component not available:", error);
}

export default function Form(props) {
  const [userDetails, setUserDetails] = useState({});
  const [content, setContent] = useState(null); // Holds the dynamic JSX content
  const [fetchedRecord, setFetchedRecord] = useState(null);
  const [loading, setLoading] = useState(false); // Add loading state

  const fetchFolkLevel = async (details) => {
    if (!details?.record_id) return; // Ensure `record_id` exists

    setLoading(true); // Start loading
    try {
      const response = await apiHelper.get({
        url: `${baseUrl}/api/fetch_folk_level`,
        params: { record_id: details.record_id }, // Use dynamic record_id
      });

      console.debug("API Response:", response);

      if (response.status && response.json && response.json.length > 0) {
        setFetchedRecord(response.json[0]);
        const folkLevel = response.json[0]["FOLK Level (Display)"];
        if (
          ["FOLK Plus", "FOLK Graduate", "FOLK Enhanced", "FOLK Prelims", "FOLK Guide", "FOLK Foundation"].includes(folkLevel)
        ) {
          setContent(
            <Box
              sx={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "150px",
                height: "150px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                borderRadius: "10px",
                backgroundColor: "#fff",
                padding: "10px",
              }}
            >
              {QRCode ? (
                <QRCode
                  value={details["record_id"] || "no detail"}
                  size={120}
                  style={{ position: "relative", zIndex: 2 }}
                />
              ) : (
                <div style={{ padding: "20px", textAlign: "center", fontSize: "14px" }}>
                  QR Code: {details["record_id"] || "no detail"}
                </div>
              )}
            </Box>
          );
        } else {
          setContent(
            <Box
              sx={{
                marginTop: "20px",
                padding: "20px",
                borderRadius: "10px",
                backgroundColor: "#f9f9f9",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
                fontSize: "14px",
              }}
            >
              <p>
                <strong>Ohh...</strong> It looks like you have not yet registered for{" "}
                <strong>FOLK (The Youth Empowerment Club)</strong>.
              </p>
              <p>
                We request you to kindly visit the <strong>Front Desk</strong>. Our Volunteers will
                assist you.
              </p>
              <p>
                <em>Stay tuned... Hare Krishna!</em>
              </p>
            </Box>
          );
        }
      } else {
        console.error("No valid data found in response.");
        setContent(<Box>Error: Unable to fetch FOLK level data.</Box>);
      }
    } catch (error) {
      console.error("Error fetching FOLK Level:", error);
      setContent(<Box>Error: Something went wrong while fetching data.</Box>);
    } finally {
      setLoading(false); // End loading
    }
  };

  useEffect(() => {
    if (userDetails.record_id) fetchFolkLevel(userDetails);
  }, [userDetails]);

  window.init = function (details) {
    console.log("Init is called");
    console.log("Data received:", details);
    setUserDetails(details); // Updating state triggers `useEffect`
  };

  return (
    <Box
      sx={{
        marginTop: "50px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#ffffff",
        padding: "20px",
      }}
    >
      <ColumnBox
        sx={{
          alignItems: "center",
          width: "100%",
          maxWidth: "400px",
          padding: "20px",
        }}
      >
        <Box
          sx={{
            marginBottom: "20px",
            fontSize: { xs: "16px", sm: "18px" },
            fontWeight: "600",
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          <Box>
            <span style={{ fontWeight: "bold", fontSize: "20px" }}>Name:</span>{" "}
            <span style={{ fontSize: "18px" }}>{userDetails["name"] || "No Name"}</span>
          </Box>
          <Box>
            <span style={{ fontWeight: "bold", fontSize: "20px" }}>Club:</span>{" "}
            <span style={{ fontSize: "18px" }}>
              {fetchedRecord?.["FOLK Recent Club"] || "No Club"}
            </span>
          </Box>
          <Box>
            <span style={{ fontWeight: "bold", fontSize: "20px" }}>FOLK Level:</span>{" "}
            <span style={{ fontSize: "18px" }}>{fetchedRecord?.["FOLK Level (Display)"] || "No Level"}</span>
          </Box>
          <Box>
            <span style={{ fontWeight: "bold", fontSize: "20px" }}>Ashraya Level:</span>{" "}
            <span style={{ fontSize: "18px" }}>{fetchedRecord?.["Current Ashraya Level"] || "No Level"}</span>
          </Box>
          <Box>
            <span style={{ fontWeight: "bold", fontSize: "20px" }}>FOLK Count:</span>{" "}
            <span style={{ fontSize: "18px" }}>{fetchedRecord?.["Count"] || "0"}</span>
          </Box>
          <Box>
            <span style={{ fontWeight: "bold", fontSize: "20px" }}>FOLK Guide:</span>{" "}
            <span style={{ fontSize: "18px" }}>
              {userDetails["folk_guide"] || "No Guide Name Present"}
            </span>
          </Box>
        </Box>
        {loading ? <p>Loading...</p> : content || <p>Hare Krishna, please chant...</p>}
        
      </ColumnBox>
    </Box>
  );
}
